<template>
  <!-- 帮帮-找帮帮 - xxx商品详情 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBackHome">帮帮</span>
        <i class="el-icon-arrow-right"></i
        ><span class="firm-clickable" @click="handelBackHome">来帮帮</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">投标 </span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- -->
        <div class="top-title">
          <p class="title">投标信息</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>

        <div class="switch-Content">
          <!-- 最终价格 -->
          <div class="Price">
            <p><span style="color: red">*</span>最终价格(人民币)：</p>
            <div class="ipt">
              <el-input
                v-model="ruleForm.Price"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <!-- 交付方式 -->
          <div class="InputLine">
            <!-- 标题 -->
            <div class="title-box">
              <p class="title"><span style="color: red">*</span>交付方式</p>
            </div>
            <!-- 输入区 -->
            <div class="content">
              <div class="CycleBody">
                <div class="column-one"></div>
                <div class="LongColumn">
                  <div class="delivery">
                    <div
                      v-for="(item, index) in TimeLimit"
                      :key="index"
                      :class="item.id == TimeLimitSelect ? 'TimeLimit' : ''"
                      @click="TimeLimitSelect = item.id"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 一期 -->
          <div class="InputLine" style="background: #fbfbfb">
            <!-- 标题 -->
            <div class="title-box">
              <p class="title"><span style="color: red">*</span>一期</p>
              <p class="title">交付内容</p>
              <div class="firm-clickable" @click="handelAddHandIn(1)">
                <p></p>
                添加
              </div>
            </div>
            <!-- 输入区 -->
            <div class="content">
              <div class="CycleBody">
                <div class="column-one"></div>
                <div class="LongColumn">
                  <div class="period-title">
                    <div class="period-title-cen">
                      一期需交付(<el-input
                        v-model="ruleForm.valueOne"
                      ></el-input
                      >)%
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="CycleBody"
                v-for="(item, index) in oneHandIn"
                :key="index"
              >
                <div class="column-one">
                  <el-input
                    placeholder="请输入"
                    v-model="item.contentTit"
                  ></el-input>
                  <div
                    class="delete-icon firm-clickable"
                    @click="handelDeleteHandIn(1, index)"
                    v-if="item.delete == '1'"
                  ></div>
                </div>
                <div class="LongColumn">
                  <div class="aloneContent">
                    <el-input
                      placeholder="请输入"
                      v-model="item.content"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 二期 -->
          <div class="InputLine">
            <!-- 标题 -->
            <div class="title-box">
              <p class="title"><span style="color: red">*</span>二期</p>
              <p class="title">交付内容</p>
              <div class="firm-clickable" @click="handelAddHandIn(2)">
                <p></p>
                添加
              </div>
            </div>
            <!-- 输入区 -->
            <div class="content">
              <div class="CycleBody">
                <div class="column-one"></div>
                <div class="LongColumn">
                  <div class="period-title">
                    <div class="period-title-cen">
                      二期需交付(<el-input
                        v-model="ruleForm.valueTwe"
                      ></el-input
                      >)%
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="CycleBody"
                v-for="(item, index) in TweHandIn"
                :key="index"
              >
                <div class="column-one">
                  <el-input
                    placeholder="请输入"
                    v-model="item.contentTit"
                  ></el-input>
                  <div
                    class="delete-icon firm-clickable"
                    @click="handelDeleteHandIn(2, index)"
                    v-if="item.delete == '1'"
                  ></div>
                </div>
                <div class="LongColumn">
                  <div class="aloneContent">
                    <el-input
                      placeholder="请输入"
                      v-model="item.content"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 三期 -->
          <div class="InputLine" style="background: #fbfbfb">
            <!-- 标题 -->
            <div class="title-box">
              <p class="title"><span style="color: red">*</span>三期</p>
              <p class="title">交付内容</p>
              <div class="firm-clickable" @click="handelAddHandIn(3)">
                <p></p>
                添加
              </div>
            </div>
            <!-- 输入区 -->
            <div class="content">
              <div class="CycleBody">
                <div class="column-one"></div>
                <div class="LongColumn">
                  <div class="period-title">
                    <div class="period-title-cen">
                      三期需交付(<el-input
                        v-model="ruleForm.valueThree"
                      ></el-input
                      >)%
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="CycleBody"
                v-for="(item, index) in ThreeHandIn"
                :key="index"
              >
                <div class="column-one">
                  <el-input
                    placeholder="请输入"
                    v-model="item.contentTit"
                  ></el-input>
                  <div
                    class="delete-icon firm-clickable"
                    @click="handelDeleteHandIn(3, index)"
                    v-if="item.delete == '1'"
                  ></div>
                </div>
                <div class="LongColumn">
                  <div class="aloneContent">
                    <el-input
                      placeholder="请输入"
                      v-model="item.content"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 服务人员 -->
          <div class="InputLine">
            <!-- 标题 -->
            <div class="title-box">
              <p class="title"><span style="color: red">*</span>服务人员</p>
              <div class="firm-clickable" @click="handelAddPeople">
                <p></p>
                添加
              </div>
            </div>
            <!-- 输入区 -->
            <div class="content">
              <div
                class="CycleBody"
                v-for="(item, index) in peopleArr"
                :key="index"
              >
                <div class="column-one">
                  <el-input placeholder="请输入" v-model="item.type"></el-input>
                  <div
                    class="delete-icon firm-clickable"
                    @click="handelDeletePeople(item, index)"
                    v-if="item.delete == '1'"
                  ></div>
                </div>
                <div class="LongColumn">
                  <div class="service-ipt">
                    <div class="people-num">
                      <el-input
                        placeholder="请输入"
                        v-model="item.num"
                      ></el-input>
                    </div>
                    <div class="people-name">
                      <el-input
                        placeholder="请输入"
                        v-model="item.name"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 交付时间 -->
          <div class="InputLine" style="background: #fbfbfb">
            <!-- 标题 -->
            <div class="title-box">
              <p class="title"><span style="color: red">*</span>预计最终</p>
              <p class="title">交付时间</p>
            </div>
            <!-- 输入区 -->
            <div class="content">
              <div class="CycleBody">
                <div class="column-one"></div>
                <div class="LongColumn">
                  <div class="service-ipt">
                    <div class="people-num">
                      <el-date-picker
                        v-model="ruleForm.time"
                        type="date"
                        placeholder="选择日期"
                      >
                      </el-date-picker>
                    </div>
                    <div class="people-name"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="Bottom-Btn">
        <div>
          <p class="firm-clickable" @click="handelVerifyTender">确认投标</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        Price: "", //最终价格
        valueOne: "", // 一期需付
        valueTwe: "", // 二期需付
        valueThree: "", // 三期需付
        time: "", // 交付时间
      }, //v-model
      TimeLimit: [
        {
          name: "全款",
          id: 1,
        },
        {
          name: "二期",
          id: 2,
        },
        {
          name: "三期",
          id: 3,
        },
      ], //几期
      TimeLimitSelect: 3, //几期选择
      oneHandIn: [
        {
          contentTit: "", // 交付
          content: "", //交付内容
        },
      ], //一期交付
      TweHandIn: [
        {
          contentTit: "", // 交付
          content: "", //交付内容
        },
      ], //二期交付
      ThreeHandIn: [
        {
          contentTit: "", // 交付
          content: "", //交付内容
        },
      ], //三期交付
      peopleArr: [
        {
          type: "", //人员类型
          num: "", //人员数量
          name: "", //人员名
        },
      ], //服务人员
    };
  },
  watch: {},
  components: {},
  created() {},
  destroyed() {},
  methods: {
    // 点击面包屑返回
    handelBackHome() {
      this.$router.push({
        path: "/HelpShop/Help",
        query: { key: 2 },
      });
    },
    // 确认投标
    handelVerifyTender() {
      // 返回帮帮页
      this.$router.push({
        path: "/HelpShop/Help",
        query: { key: 2 },
      });
    },

    // 返回
    handelBack() {
      // 存入select 返回/HelpShop的同时获取到select  select中的数就是该页面所在的位置
      // sessionStorage.setItem("select", 2);
      this.$router.push({
        path: "/HelpShop/Help/ComeAndHelp",
      });
    },
    // 添加服务人员
    handelAddPeople() {
      var obj = {
        type: "", //人员类型
        num: "", //人员数量
        name: "", //人员名
        delete: "1", //有此数据 可删除
      };
      // 点击添加
      this.peopleArr.push(obj);
    },
    // 删除 服务人员 输入框
    handelDeletePeople(item, index) {
      this.peopleArr.splice(index, 1);
    },
    // 添加交付
    handelAddHandIn(num) {
      if (num == 1) {
        // 一期
        var obj = {
          contentTit: "", // 交付
          content: "", //交付内容
          delete: "1", //有此数据 可删除
        };
        // 点击添加 在一期交付内容后添加输入框
        this.oneHandIn.push(obj);
      } else if (num == 2) {
        // 二期
        var obj = {
          contentTit: "", // 交付
          content: "", //交付内容
          delete: "1", //有此数据 可删除
        };
        // 点击添加 在二期交付内容后添加输入框
        this.TweHandIn.push(obj);
      } else if (num == 3) {
        //三期
        var obj = {
          contentTit: "", // 交付
          content: "", //交付内容
          delete: "1", //有此数据 可删除
        };
        // 点击添加 在三期交付内容后添加输入框
        this.ThreeHandIn.push(obj);
      }
    },
    // 删除交付内容
    handelDeleteHandIn(num, index) {
      if (num == 1) {
        // 一期
        // 点击删除 在一期交付内容 中删除一行输入框
        this.oneHandIn.splice(index, 1);
      } else if (num == 2) {
        // 二期
        // 点击删除 在二期交付内容 中删除一行输入框
        this.TweHandIn.splice(index, 1);
      } else if (num == 3) {
        // 三期
        // 点击删除 在三期交付内容 中删除一行输入框
        this.ThreeHandIn.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  //
  .switch-Content {
    width: 100%;
    margin-top: 30px;
    // 招标信息 参标信息 标题
    .title-p {
      width: 85px;
      height: 25px;
      background-image: url("../../../../assets/imgs/zhuangshi@3x.svg");
      background-size: 100% 35%;
      background-repeat: no-repeat;
      background-position-y: bottom;
      font-size: 20px;
      margin: 50px 0px 30px 0px;
    }
    // 表单输入区
    .Price {
      width: 500px;
      height: 35px;
      line-height: 35px;
      display: flex;
      margin-top: 50px;
      margin-bottom: 30px;
      .ipt {
        flex: 1;
      }
    }
    // 交付方式
    .InputLine {
      width: 100%;
      background: #eeeeee;
      min-height: 35px;
      padding: 10px 0px 10px 0px;
      display: flex;
      .title-box {
        width: 80px;
        margin: auto 0;
        text-align: center;
        margin-left: 10px;
        div {
          width: 50px;
          height: 18px;
          line-height: 18px;
          display: flex;
          font-size: 12px;
          color: #333333;
          margin: 0 auto;
          margin-top: 5px;
          p {
            width: 18px;
            height: 18px;
            background-image: url("../../../../assets/imgs/tianjia@3x.svg");
            background-size: 100% 100%;
            margin-right: 5px;
          }
        }
      }
      // 内容输入区
      .content {
        flex: 1;
        min-height: 35px;
        margin-left: 20px;
        .CycleBody:nth-child(1) {
          margin-top: 0px;
        }
        .CycleBody {
          width: 100%;
          height: 35px;
          margin-top: 10px;
          display: flex;
          // 第一列
          .column-one {
            width: 120px;
            min-height: 35px;
            position: relative;
            .delete-icon {
              width: 16px;
              height: 17px;
              background-image: url("../../../../assets/imgs/shanchu@3x.svg");
              background-size: 100% 100%;
              position: absolute;
              right: 5px;
              top: 8px;
            }
          }
          // 第二长列
          .LongColumn {
            flex: 1;
            height: 35px;
            margin-left: 10px;
            margin-right: 10px;
            display: flex;
            // 支付方式  选择 全款二期三期
            .delivery {
              width: 210px;
              height: 25px;
              margin: auto;
              display: flex;
              div {
                width: 66px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                background: #ffffff;
                font-size: 12px;
                color: #666666;
              }
              div:nth-child(1) {
                border-radius: 15px 0px 0px 15px;
                border: 1px solid #409eff ;
              }
              div:nth-child(2) {
                border-top: 1px solid #409eff ;
                border-bottom: 1px solid #409eff ;
              }
              div:nth-child(3) {
                border-radius: 0px 15px 15px 0px;
                border: 1px solid #409eff ;
              }
              .TimeLimit {
                color: #ffffff;
                background: #409eff ;
              }
            }
            //需要付
            .period-title {
              width: 100%;
              min-height: 35px;
              line-height: 35px;
              display: flex;
              background: rgba(97, 144, 232, 0.2);
              border: 1px solid #409eff ;
              border-radius: 5px;
              .period-title-cen {
                width: 150px;
                margin: auto;
                display: flex;
                font-size: 12px;
                color: #409eff ;
                /deep/.el-input {
                  height: 35px !important;
                  width: 60px;
                  border: none;
                }
                /deep/.el-input__inner {
                  height: 35px !important;
                  width: 60px;
                  border: none !important;
                  background: transparent;
                }
              }
            }
            // 一行一个输入框  独占一行
            .aloneContent {
              width: 100%;
              height: 35px;
            }
            // 一行二个输入框
            .service-ipt {
              width: 100%;
              height: 35px;
              display: flex;
              .people-num {
                width: 300px;
                height: 35px;
              }
              .people-name {
                flex: 1;
                height: 35px;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
  // 招标信息
  .mine-attendContent {
    width: 100%;
    min-height: 200px;
  }
  .attendContent {
    width: 100%;
    min-height: 600px;
  }
}
.Bottom-Btn {
  height: 35px;
  background: #ffffff;
  box-shadow: 0px -5px 10px 0px rgba(153, 153, 153, 0.5);
  border-radius: 0px 0px 20px 20px;
  margin-top: -30px;
  margin-bottom: 20px;
  display: flex;
  padding: 20px;
  p {
    width: 120px;
    height: 40px;
    background: #409eff ;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin: auto 0;
    margin-left: 20px;
  }
  div {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
